<template lang="pug">
  .leads.white
    v-container.pa-0
      div.mb-0(height="100px" flat outlined)
        //- SUMMARY
        
        //- TAB & BUTTON
        v-row.main-container.mt-4(no-gutters align="center" :class="{ 'mx-4': $vuetify.breakpoint.smAndUp }")
          v-col
            v-tabs(v-model="tab" fixed-tabs color="primary" height="40" slider-size="2")
              v-tab.button-AA-small {{ $t('today') }}
              v-tab.button-AA-small {{ $t('yesterday') }}
          v-col(align="right")
            v-btn.mr-4(color="transparent" small icon @click="openMessageTemplate = true")
              eva-icon.mb-n1(name="edit-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="20" width="20")
            v-btn.mr-4(color="transparent" small icon @click="!ordering ? ordering = 'newest' : ordering === 'newest' ? ordering = 'oldest' : ordering = 'newest'")
              v-icon(v-if="ordering === 'newest'" color="primary400" size="20") mdi-sort-descending
              v-icon(v-else-if="ordering === 'oldest'" color="primary400" size="20") mdi-sort-ascending
              v-icon(v-else color="primary400" size="20") mdi-sort
          div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

    v-container.pa-0.mt-3

      //- FETCHING
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      
      template(v-else)
        //- TO BE CONTACTED HEADER
        div.d-flex.align-center.px-4.py-3
          div.h6.basic700--text {{ $t('to_be_contacted') }}
          div.p1.basic600--text.ml-2 {{ toBeContactedLeads.length }}
          v-spacer
          //- v-chip.button-AA-tiny.px-2(color="info400" dark small) NEW

        //- EMPTY TO BE CONTACTED LEADS
        v-layout.my-6.px-2.pt-2(v-if="toBeContactedLeads.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/order_mgmt_empty.png')" style="width:80px; height:80px" contain)
              div.p2.basic600--text.text-center {{ $t('no_leads_found') }}

        //- TO BE CONTACTED LEADS LIST
        div(v-else)
          v-divider.basic300
          div(v-for="(lead, index) in toBeContactedLeads" :key="lead.id")
            follow-up-item(:parentLead.sync="lead" :menu="menu" source="tbcontacted" :company="company" :messageTemplate="messageTemplate" :day="day" @openSubscribe="openFollowUpSubscription = true")
            v-divider.basic300

        div(style="height: 16px; background-color: var(--v-basic600T08)")

        //- CONTACTED HEADER
        div.d-flex.align-center.px-4.py-3
          div.h6.basic700--text {{ $t('contacted') }}
          div.p1.basic600--text.ml-2 {{ contactedLeads.length }}
          v-spacer
          //- v-chip.button-AA-tiny.px-2(color="warning500" dark small) FOLLOW-UP

        //- EMPTY CONTACTED LEADS
        v-layout.my-6.px-2.pt-2(v-if="contactedLeads.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/order_mgmt_empty.png')" style="width:80px; height:80px" contain)
              div.p2.basic600--text.text-center {{ $t('no_leads_found') }}

        //- CONTACTED LEADS LIST
        div(v-else)
          v-divider.basic300
          div(v-for="(lead, index) in contactedLeads" :key="lead.id")
            follow-up-item(:parentLead.sync="lead" :menu="menu" source="contacted" :company="company" :messageTemplate="messageTemplate" :day="day" @openSubscribe="openFollowUpSubscription = true")
            v-divider.basic300

    .modal
      edit-message-template(v-if="openMessageTemplate" :open.sync="openMessageTemplate" :company="company" @updated="checkMessageTemplate")
      follow-up-details-filter(v-if="openFollowUpDetailsFilter" :open.sync="openFollowUpDetailsFilter")
      follow-up-subscription(v-if="openFollowUpSubscription" :open.sync="openFollowUpSubscription" :company="company" :upgrade="true")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import FollowUpItem from '@/components/FollowUpItem.vue'
import EditMessageTemplate from '@/components/dialogs/followup/EditMessageTemplate.vue'
import FollowUpDetailsFilter from '@/components/dialogs/followup/FollowUpDetailsFilter.vue'
import FollowUpSubscription from '@/components/dialogs/followup/FollowUpSubscription.vue'

export default {
  name: 'FollowUp',
  components: { FollowUpItem, EditMessageTemplate, FollowUpDetailsFilter, FollowUpSubscription },
  props: ['company', 'menu'],
  data: () => ({
    isFetching: false,
    isFetchingSummary: false,
    openMessageTemplate: false,
    openFollowUpDetailsFilter: false,
    openFollowUpSubscription: false,
    tab: 0,
    leads: [],
    summary: {},
    messageTemplate: null,
    ordering: null
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    contactedLeads () {
      if (this.leads.length > 0) {
        return this.leads.filter(lead => lead.taggings.filter(f => f.tagging === 'contacted').length > 0)
      }
      return []
    },
    toBeContactedLeads () {
      if (this.leads.length > 0) {
        return this.leads.filter(lead => lead.taggings.filter(f => f.tagging === 'contacted').length === 0)
      }
      return []
    },
    day () {
      if (this.tab === 0) {
        return 'today'
      } else {
        return 'yesterday'
      }
    }
  },
  watch: {
    tab () {
      this.fetchLeads()
    },
    ordering () {
      this.fetchLeads()
    }
  },
  mounted () {
    this.$store.commit('followup/recoverFollowUpDetails')
    this.fullscreen = window.innerWidth < 600
    if (this.$route.query && this.$route.query.range === 'yesterday') {
      this.tab = 1
    } else {
      this.fetchLeads()
      this.fetchSummaryLeads()
    }
    this.checkMessageTemplate()
    if (this.$route.query && this.$route.query.subscribe === 'true') {
      setTimeout(() => {
        if (!this.Auth('component', '/admin/follow-up#follow_up_action')) {
          this.openFollowUpSubscription = true
        }
      }, 2000)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchLeads () {
      this.isFetching = true
      let url = `/leads/sales_recovery?page_size=-1&company=${this.company.id}&range=${this.day}`
      // let url = `/leads?member=${this.member.id}`
      if (this.ordering) {
        if (this.ordering === 'newest') {
          url += '&ordering=-created'
        } else {
          url += '&ordering=created'
        }
      }
      if (this.member.role !== 'Admin') {
        url += `&member=${this.member.id}`
      }
      this.$axios.get(url)
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.leads = resp.data.results
          } else {
            this.leads = []
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchSummaryLeads () {
      this.isFetchingSummary = true
      let url = `/leads/sales_recovery/summary?range=${this.day}&company=${this.company.id}`
      if (this.member.role !== 'Admin') {
        url += `&member=${this.member.id}`
      }
      this.$axios.get(url)
        .then(resp => {
          this.summary = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingSummary = false
        })
    },
    checkMessageTemplate () {
      this.$axios.get(`/companies/${this.company.id}/settings`)
        .then(resp => {
          if (resp.data.results.length > 0) {
            if (resp.data.results.filter(f => f.name === 'yz.sales_recovery.message_template').length > 0) {
              let message = resp.data.results.filter(f => f.name === 'yz.sales_recovery.message_template')[0]
              if (message.extra_data && typeof message.extra_data === 'string') {
                this.messageTemplate = message.extra_data
              } else {
                this.messageTemplate = null
              }
            }
          }
        })
        .catch(() => {})
    },
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:4px;
  top: 36px;
  left: 0px;
  right: 0px;
}
</style>

<i18n>
{
  "en": {
    "sales_recovered": "Sales recovered",
    "potential_sales": "Potential sales",
    "to_be_contacted": "To be contacted",
    "no_leads_found": "No leads found",
    "contacted": "Contacted"
  },
  "id": {
    "sales_recovered": "Penjualan",
    "potential_sales": "Potensi Penjualan",
    "to_be_contacted": "Perlu dihubungi",
    "no_leads_found": "Tidak ada lead",
    "contacted": "Telah dihubungi"
  }
}
</i18n>
